import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import { DownloadDeductionsReportRequest, reportsService } from '@aslanpay/portal-common-lib';

const useDownloadDeductionsReport = ({
  onSuccess,
  onError,
}: UseMutationOptions<unknown, Error, DownloadDeductionsReportRequest>) => {
  return useMutation<unknown, Error, DownloadDeductionsReportRequest>(
    ({ id }: DownloadDeductionsReportRequest) => reportsService.downloadDeductionsReport({ id }),
    { onSuccess, onError }
  );
};

export default useDownloadDeductionsReport;
